<template>
  <div class="rep__card">
    <div class="name">{{rep.first_name}} {{rep.last_name}}</div>
    <div class="note">{{rep.note}}</div>
    <div class="phone">{{rep.phone}}</div>
    <div class="email">{{rep.email}}</div>
    <div class="contact">
      <a v-if="rep.phone" :href="'tel:' + rep.phone" class="click">
        Call
      </a>
      <a v-if="rep.email" :href="'mailto:' + rep.email" class="click">
        Email
      </a>
    </div>
  </div>
</template>

<script>
import {store} from '@/store'
export default {
  name: 'RepCard',
  props: {
    rep: Object
  }
}
</script>

<style scoped lang="less">
.shadow {
  box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.25);
}
.rep__card {
  display: block;
  padding: 18px 18px 60px 18px;
  box-sizing: border-box;
  width: calc(100% / 3 - 12px);
  margin: 6px;
  position: relative;
  overflow: hidden;
  border-radius: 3px;
  background-color: white;
  &:extend(.shadow);

  @media screen and (max-width:768px) {
    width: calc(50% - 12px);
  }

  @media screen and (max-width: 425px) {
    width: calc(100% - 12px)
  }

  .name {
    font-weight: bold;
    font-size: 1em;
  }
  .note {
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: dashed 1px lightgray;
    font-size: 0.8em;
    font-style: italic;
  }
  .phone, 
  .email {
    font-size: 0.8em;
  }
  .contact {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: ;
    margin-top: 12px;
    position: absolute;
    bottom: 12px;
    left: 12px;
    box-sizing: border-box;
    border: solid 1px lightgray;
    border-radius: 6px;
    overflow: hidden;
    a {
      display: block;
      width: 75px;
      padding: 6px;
      text-align: center;
      cursor: pointer;
      box-sizing: border-box;
      color: #333333 !important;
      font-size: 0.8em;
      font-weight: bold;
      text-decoration: none;
      transition: 0.25s;
      &:nth-child(2){
        border-left: solid 1px lightgray;
      }
      &:hover {
        background-color: #f4f4f4;
      }
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/mainpage/RepCard.vue